export default __webpack_public_path__ + "static/media/avatar-mp-2-3.e4613c7e.png";